import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=2139a9f8"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports